import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2rem;
  & .left-title {
    text-align: left;
  }
  & .top-form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
  & .edit {
    display: flex;
    flex-direction: row;
    & p {
      margin-right: 0.5rem;
    }
  }
  & .form-fields {
    display: flex;
    flex-wrap: wrap;
    & .field {
      margin: 0.5rem;
      min-width: 48%;
      p {
        max-height: 3rem;
      }
    }
    & .field-line {
      margin: 0.5rem;
      min-width: 98%;
      p {
        max-height: 3rem;
      }
    }
    & .left-field {
      margin: 0.5rem 29.5rem 0.5rem 0.5rem;
      p {
        align-self: left;
        width: 27rem;
        max-height: 3rem;
      }
    }
  }
  & .middle-line {
    margin-top: 2rem;
  }
`;
